import { ListGroup, ListGroupItem, Placeholder } from "react-bootstrap";


import { faCheckCircle, faList, faPlus, faSpinner, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { callQuery, Favorite, FAVORITES_BY_USERNAME_AND_CSN } from "../../amplify/api-gateway/query";
import { callWrite, DELETE_FAVORITE, INSERT_FAVORITE } from "../../amplify/api-gateway/write";


interface FavoriteContextMenuProps {
    show: boolean;
    setShow: any;
    contextMenu: any;
    lists: string[];
    setShowNewList: any;
    updateCsnToFavorites: any;
}


export const FavoriteContextMenu = (props: FavoriteContextMenuProps) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [itemBeingActionedOn, setItemBeingActionedOn] = useState<any>(null);
    const [active, setActive] = useState<string[]>([]);

    useEffect(() => {
        console.log("CONTEXT MENU CHANGED", props.contextMenu)
        if (props.contextMenu && props.contextMenu.patient && props.contextMenu.patient.csn && props.show) {
            setIsLoading(true);
            callQuery({
                operation: FAVORITES_BY_USERNAME_AND_CSN,
                csn: props.contextMenu.patient.csn,
            })
            .then((favorites: any[]) => {
                setIsLoading(false);
                // csn, mrn, internal_csn, internal_mrn, favorite_time, favorite_type, username
                const updatedActive = favorites.map((fav) => {
                    return fav.favorite_type;
                });
                setActive(updatedActive);
            });
        }
    }, [props.contextMenu]);

    const deleteFavorite = (listName: string) => {
        setItemBeingActionedOn(listName);
        callWrite({
            operation: DELETE_FAVORITE,
            favorite_type: listName,
            csn: props.contextMenu.patient.csn,
        })
        .then((output: Favorite) => {
            console.log("Deleted favorite", output);
            // Purposefully don't pass output to update code to indicate deletion
            setItemBeingActionedOn(null);
            props.updateCsnToFavorites(props.contextMenu.patient.csn, listName);
        });
    };

    const saveFavorite = (listName: string) => {
        setItemBeingActionedOn(listName);
        callWrite({
            operation: INSERT_FAVORITE,
            favorite_time: new Date().getTime(),
            favorite_type: listName,
            csn: props.contextMenu.patient.csn,
            mrn: props.contextMenu.patient.mrn,
            internal_csn: props.contextMenu.patient.internal_csn,
            internal_mrn: props.contextMenu.patient.internal_mrn,
        })
        .then((output: Favorite[]) => {
            console.log("Saved favorite", output[0]);
            setItemBeingActionedOn(null);
            props.updateCsnToFavorites(props.contextMenu.patient.csn, listName, output[0]);
        });
    }

    const handleClick = (isCurrentlySaved: boolean, listName: string) => {
        if (isCurrentlySaved) {
            deleteFavorite(listName);
        } else {
            saveFavorite(listName);
        }
    };

    const handleNewList = () => {
        props.setShow(false);
        props.setShowNewList(true);
    };

    if (props.show) {
        return (
            <div style={{zIndex: 99999, padding: '0px', position: 'absolute', top: `${props.contextMenu.y}px`, left: `${props.contextMenu.x}px`, width: '200px', marginLeft: '-185px', marginTop: '-18px', boxShadow: '0 0 8px rgba(61, 61, 61, 0.4)'}}>
                {
                    isLoading ? (
                        <ListGroup>
                            {
                                [1, 2, 3].map((v) => (
                                    <ListGroupItem key={v}>
                                        <Placeholder animation="glow">
                                            <Placeholder xs={6} size="xs" />
                                        </Placeholder>
                                    </ListGroupItem>
                                ))
                            }
                        </ListGroup>
                    ) : (
                        <ListGroup>
                            {
                                props.lists.map(list => (
                                    <ListGroupItem key={list} action onClick={() => {handleClick(active.includes(list), list)}} active={active.includes(list)}>
                                        <FontAwesomeIcon icon={itemBeingActionedOn === list ? faSpinner : active.includes(list) ? faCheckCircle : list === "favorite" ? faStar : faList} style={{marginRight: '12px'}} spin={itemBeingActionedOn === list} />{list === "favorite" ? "Favorite" : list}
                                    </ListGroupItem>
                                ))
                            }
                            <ListGroupItem action onClick={handleNewList}>
                                <FontAwesomeIcon icon={faPlus} style={{marginRight: '12px'}} />{' '}New List
                            </ListGroupItem>
                        </ListGroup>
                    )
                }
            </div>
        );
    } else {
        return <></>;
    }
};
